exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-heading {\n  display: block;\n  padding-top: 5px;\n}\n\n.content-page-intro h2 {\n  font-family: \"Lato\", Helvetica, Arial, sans-serif;\n  font-weight: 300;\n  line-height: 48px;\n}\n.boldtext{font-weight: 700;}\n\n@media(max-width: 640px) {\n  .inline-heading {\n    display: block;\n    padding-top: 0px;\n  }\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/terms-condition/terms-condition.component.css
// module id = ../../../../../src/app/pages/terms-condition/terms-condition.component.css
// module chunks = main